import Box from "@mui/material/Box";
import * as React from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../components/SideBar";

const AssuranceDashbordLayout = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <SideBar />
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: "background.default", p: 3, mt: 8 }}
      >
        <div>
          <Outlet />
        </div>
      </Box>
    </Box>
  );
};

export default AssuranceDashbordLayout;
